import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations, LANGS } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem("ekobiotek_lang");
    if (stored && translations[stored]) return stored;
    return "en";
  });

  useEffect(() => {
    window.localStorage.setItem("ekobiotek_lang", lang);
    document.documentElement.lang = lang === "ua" ? "uk" : lang;
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang],
      langs: LANGS,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
